import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgInspectionItem } from '../models/reports/jg-inspection-item.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionJgItemService extends RequestService<JgInspectionItem> {
  static PATH = '/inspection/jg/item';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, InspectionJgItemService.PATH, globalService.debugUrl);
  }
}
